import { render } from "./EditQuestionPage.vue?vue&type=template&id=a567ef30&scoped=true"
import script from "./EditQuestionPage.vue?vue&type=script&lang=js"
export * from "./EditQuestionPage.vue?vue&type=script&lang=js"

import "./EditQuestionPage.vue?vue&type=style&index=0&id=a567ef30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a567ef30"]])

export default __exports__